<template>
  <div>
    <v-card color="grey lighten-1 white--text">
      <v-layout align-center row>
        <v-flex xs6 md6 pl-3> Availability Region Priority </v-flex>
      </v-layout>
    </v-card>
    <draggable v-model="availabilityRegionStore" @change="orderChanged">
      <v-card
        v-for="ar in availabilityRegionStore"
        :key="ar.id"
        :color="ar.enabled ? 'white' : 'grey lighten-2'"
      >
        <v-layout align-center row>
          <v-flex xs6 md6>
            <v-card-title
              ><h3>{{ ar.name }}</h3></v-card-title
            >
          </v-flex>
      
        </v-layout>
      </v-card>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "ride_type_list",
  components: {
    draggable,
  },
  props: {
    availability_regions: Array,
    loading: Boolean,
    loadingCostEstimates: Boolean,
  },
  data: function () {
    return {
      availabilityRegionStore: [],
    };
  },
  beforeMount: async function () {
    this.availabilityRegionStore = this.availability_regions;
  },
  methods: {
    edit: function (id) {
      this.$emit("edit", id);
    },
    orderChanged: function () {
      this.$emit("orderChange", this.availabilityRegionStore);
    },
    getTariffName: function (tariff) {
      if (tariff.name) {
        return tariff.name + " Modifier";
      } else {
        return "Base Tariff";
      }
    },
  },
  watch: {
    ride_types: function () {
      this.availabilityRegionStore = this.ride_types;
    },
    availabilityRegionStore: function () {},
  },
};
</script>
